/**
 * Simulation settings hook — persists slider overrides to the database.
 *
 * Instead of losing slider state on page refresh, settings are saved
 * per-user and restored on next load.
 */
import { useState, useEffect, useCallback, useRef } from 'react'
import { api } from '../lib/api'

export function useSimulationSettings(orgId) {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const saveTimerRef = useRef(null)

  useEffect(() => {
    if (!orgId) {
      setLoading(false)
      return
    }

    api.get(`/simulation/${orgId}`)
      .then(data => {
        setSettings(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Failed to load simulation settings:', err)
        setLoading(false)
      })
  }, [orgId])

  // Debounced save — writes to API 500ms after last change
  const updateSettings = useCallback((updates) => {
    setSettings(prev => ({ ...prev, ...updates }))

    if (saveTimerRef.current) clearTimeout(saveTimerRef.current)
    saveTimerRef.current = setTimeout(() => {
      api.put(`/simulation/${orgId}`, updates).catch(err => {
        console.error('Failed to save simulation settings:', err)
      })
    }, 500)
  }, [orgId])

  return { settings, loading, updateSettings }
}
